var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"ods-dropdown-menu__item",class:{
    'is-disabled': _vm.disabled,
    'ods-dropdown-menu__item--divided': _vm.divided
  },attrs:{"aria-disabled":_vm.disabled,"tabindex":_vm.disabled ? null : -1},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }